module.exports = __webpack_public_path__ + "static/media/car_warranty.4c6a080a.svg";